import { render, staticRenderFns } from "./ContentSwiper.vue?vue&type=template&id=2f51b4d5&scoped=true"
import script from "./ContentSwiper.vue?vue&type=script&lang=ts"
export * from "./ContentSwiper.vue?vue&type=script&lang=ts"
import style0 from "./ContentSwiper.vue?vue&type=style&index=0&id=2f51b4d5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f51b4d5",
  null
  
)

export default component.exports